'use strict';

module.exports = require('./Trigger');


/*****************
 ** WEBPACK FOOTER
 ** ./~/rc-trigger/lib/index.js
 ** module id = 216
 ** module chunks = 0
 **/